import { render, staticRenderFns } from "./CommonSummary.vue?vue&type=template&id=97824de6"
import script from "./CommonSummary.vue?vue&type=script&lang=js"
export * from "./CommonSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports